export default {
  1: 'Processando',
  2: 'Autorizado',
  3: 'Pago',
  4: 'Reembolsado',
  5: 'Aguardando pagamento',
  6: 'Reembolso pendente',
  7: 'Negado',
  8: 'Cancelado',
  9: 'Não pago',
  10: 'Pago parcialmente',
  11: 'Aguardando pix'
}
